import { getQueryParams } from '@office-start/url-parser-utility';
import * as React from 'react';
var appBarDefaultPinSetOverrideQueryParam = 'appBarDefaultPinSetOverride';
/**
 * Custom React Hook responsible for resolving the default pin set override based on the query string
 * Use `appBarDefaultPinSetOverride=A`, `appBarDefaultPinSetOverride=B`,
 *     `appBarDefaultPinSetOverride=C`, or `appBarDefaultPinSetOverride=D` to set a default pin set
 * Use `appBarDefaultPinSetOverride=` to reset the pinned apps to user defaults
 */
export function useDefaultPinSetOverride() {
    return React.useMemo(function () {
        return getQueryParams(location.search)[appBarDefaultPinSetOverrideQueryParam];
    }, []);
}
//# sourceMappingURL=useDefaultPinSetOverride.js.map